import { findSlotsByScheduleIds } from '@/app/(main)/(pages)/_services/search-api/search-api.service';
import { SearchApiDayTime } from '@/app/(main)/(pages)/_types/search-api-response.type';
import { SchedulesSearchSlot, SlotStatus } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-slot.type';

export interface GETScheduleSlotParams {
  limitDays: number;
  offsetDays: number;
  id: string;
  dayTime?: SearchApiDayTime;
  minDate?: string;
  maxDate?: string;
}

export interface GETScheduleSlotResult {
  slots: SchedulesSearchSlot[];
  hasMore: boolean;
}

export async function getSchedulesSlotById({
  id, limitDays, offsetDays, dayTime, minDate, maxDate,
}: GETScheduleSlotParams): Promise<GETScheduleSlotResult> {
  const { groups, hasMore } = await findSlotsByScheduleIds([id], {
    limitDays, offsetDays, dayTime, minDate, maxDate,
  });
  const group = groups.find((item) => item.scheduleId === id);

  const slots = (group?.slots ?? []).map((slot) => ({
    id: slot.id,
    date: slot.date,
    start: slot.start,
    end: slot.end,
    status: slot.status?.toUpperCase() === 'AVAILABLE' ? SlotStatus.AVAILABLE : SlotStatus.UNAVAILABLE,
    type: slot.type,
    scheduleId: id,
  }));

  return { slots, hasMore };
}
